/**
 * @generated SignedSource<<7851732bca89a1dba9caf0e1b29362df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamHomeNavigator_home$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_home">;
  readonly " $fragmentType": "TeamHomeNavigator_home";
};
export type TeamHomeNavigator_home$key = {
  readonly " $data"?: TeamHomeNavigator_home$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHomeNavigator_home">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamHomeNavigator_home",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHeader_home"
    }
  ],
  "type": "HomeUnion",
  "abstractKey": "__isHomeUnion"
};

(node as any).hash = "42786b561e0f355b0b021a16f3c363e5";

export default node;
